import InviteContent from "./Content";
import InviteSummary from "./Summary";

export const InviteStep = {
  Content: InviteContent,
  Summary: InviteSummary
}